// This is the default environment for the production build.
// If you want a custom project environment, you can create a file called `environment.prod.ts` in
// /projects/web/src/assets/projects/PROJECT_NAME/ and cp in in the build process in .gitlab-ci.yml
// to override this file.

export const environment = {
  name: 'production', // Just for information and logging purposes.
  production: true,
  // Needs to be here to prevent undefined bugs, but is not set, to not initialize it.
  firebase: {
    apiKey: '',
    //   authDomain: 'leaderboard-developer-demo.firebaseapp.com',
    //   projectId: 'leaderboard-developer-demo',
    //   storageBucket: 'leaderboard-developer-demo.appspot.com',
    //   messagingSenderId: '359126940794',
    appId: '',
  },
  // Sentry Config: https://docs.sentry.io/platforms/javascript/guides/angular
  // Needs to be here to prevent undefined bugs, but is not set, to not initialize it.
  sentry: {
    dsn: '',
  },
};
